import { Fragment, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { PropTypes } from 'prop-types';
import {
  errorStyle,
  successStyle,
  concreteStyle,
  concreteErrorStyle,
  dayStyle,
  concreteErrorStyleDay,
} from '../../../../../components/RegionSelect/style';
import './iconsEffect.css';
import ReloadIcon from './reloadIcon';
import AccionaTooltip from '../../../../../components/AccionaTooltip';

const ScannedDocTable = ({
  regions,
  onClick,
  updateForm,
  formState,
  selectedRegion,
  unLockedRegion,
  onClickLock,
  formValidate,
  dispatchValidable,
  setForceTooltip,
  forceTooltip,
  readOtherRegions,
  disableLocks,
  disableReload,
}) => {
  const intl = useIntl();
  const [regionsG1, setRegionsG1] = useState([]);
  const [regionsG2, setRegionsG2] = useState([]);

  useEffect(() => {
    const index = regions.findIndex((region) => region.data === 'compound');
    if (index > -1) {
      setRegionsG1(regions.slice(0, index));
      setRegionsG2(regions.slice(index));
    } else setRegionsG1(regions);
  }, [regions]);
  const manualValidation = (validated, key) => {
    if (validated === true && formState[key].status.length === 0) {
      dispatchValidable({ type: true, key: key });
    } else if (validated === false)
      dispatchValidable({ type: validated, key: key });
  };

  const manualValidationCS = (validated, key) => {
    const errors = Object.keys(formState.compressive_strength.status).reduce(
      (previus, key) => {
        return previus + formState.compressive_strength.status[key]?.length;
      },
      0,
    );
    if (errors === 0 && validated === true) {
      dispatchValidable({ type: true, key: key });
    } else if (validated === false)
      dispatchValidable({ type: validated, key: key });
  };

  const [showToolTip, setShowToolTip] = useState('');

  useEffect(() => {
    if (forceTooltip) setShowToolTip('all');
    setForceTooltip(false);
  }, [forceTooltip, setForceTooltip]);

  const limitTimeRegion = (region) => {
    const isLoading = formState[region.data].loading === 'loading';
    return (
      <div key="timeBlock">
        <li
          onMouseOver={() => setShowToolTip(region.data)}
          onMouseOut={() => setShowToolTip('')}
          key={`formTable-li-${region.index}`}
          id={`formTable-li-${region.index}`}
        >
          <div
            style={{
              backgroundColor:
                selectedRegion === region.data
                  ? 'rgba(240, 150, 0, 0.6)'
                  : 'white',
            }}
          >
            <div style={{ padding: '15px 0px 0px 25px', position: 'absolute' }}>
              <AccionaTooltip
                label={region.data}
                status={formState[region.data]?.status}
                showToolTip={
                  showToolTip === region.data || showToolTip === 'all'
                }
              />
            </div>
            <input
              onChange={() => {}}
              checked={false}
              type="checkbox"
              id={`formTable-input-${region.index}`}
              value={region.index}
            />
            <label
              onClick={(e) => onClick(e, region)}
              style={{ padding: '10px' }}
              id={`formTable-label-${region.index}`}
            >
              {intl.formatMessage({ id: `attr.${region.data}` })}
              <div
                className="row"
                style={{
                  margin: '2px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '0px',
                }}
              >
                {!disableLocks && (
                  <div
                    style={{ padding: '0px' }}
                    className="col-xs-1 col-sm-1 col-md-1"
                  >
                    {isLoading ? (
                      <i
                        className="fa fa-spinner fa-spin iconRed"
                        aria-hidden="true"
                      />
                    ) : unLockedRegion !== region.data ? (
                      <i
                        onClick={() => onClickLock(region.data)}
                        className="icon fas fa-lock iconGreen fa-lg"
                      />
                    ) : (
                      <i
                        onClick={() => onClickLock(region.data)}
                        className="icon fas fa-unlock-alt iconRed fa-lg"
                      />
                    )}
                  </div>
                )}
                <input
                  className="testMio"
                  value={formState[region.data]?.value}
                  disabled={isLoading || !region.data}
                  onChange={(event) =>
                    updateForm(region.data, event.target.value)
                  }
                  type="text"
                  style={
                    formState[region.data]?.status.length
                      ? errorStyle
                      : successStyle
                  }
                />
                {formValidate[region.data] !== undefined ? (
                  <div
                    style={{ padding: '0px' }}
                    className="col-xs-1 col-sm-1 col-md-1"
                  >
                    {formValidate[region.data] === true ? (
                      <i
                        style={{ float: 'right' }}
                        onClick={() => manualValidation(false, region.data)}
                        className="iconGreen fas fa-check-circle fa-lg"
                      ></i>
                    ) : (
                      <i
                        style={{ float: 'right' }}
                        onClick={() => manualValidation(true, region.data)}
                        className="iconRed fas fa-times-circle fa-lg"
                      ></i>
                    )}
                  </div>
                ) : null}
              </div>
            </label>
          </div>
        </li>
        <li disabled key="formTable-li-x" id="formTable-li-x">
          <div style={{ backgroundColor: 'white' }}>
            <input
              disabled
              onChange={() => {}}
              checked={false}
              type="checkbox"
              id="formTable-input-x"
            />
            <label style={{ padding: '10px' }} id="formTable-label-x">
              {intl.formatMessage({ id: `attr.limit_time` })}
              <div
                className="row"
                style={{
                  margin: '2px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '0px',
                }}
              >
                <input
                  value={formState['limit_time']?.value}
                  disabled
                  type="text"
                  style={
                    formState['limit_time']?.status.length
                      ? errorStyle
                      : successStyle
                  }
                />
              </div>
            </label>
          </div>
        </li>
      </div>
    );
  };

  const compressiveStrengthRegion = (region) => {
    return (
      <li
        key={`formTable-li-${region.index}`}
        id={`formTable-li-${region.index}`}
      >
        <div
          style={{
            backgroundColor:
              selectedRegion === region.data
                ? 'rgba(240, 150, 0, 0.6)'
                : 'white',
          }}
        >
          <input
            onChange={() => {}}
            checked={false}
            type="checkbox"
            id={`formTable-input-${region.index}`}
            value={region.index}
          />

          <label
            onClick={(e) => onClick(e, region)}
            style={{
              padding: '10px',
              ...(formState.compressive_strength?.status.length
                ? { outline: '1px solid #ff0000' }
                : {}),
            }}
            id={`formTable-label-${region.index}`}
          >
            <div onMouseOut={() => setShowToolTip('')}>
              {intl.formatMessage({ id: `attr.${region.data}` })}
              <i
                style={{ marginLeft: 15 }}
                className="icon fas fa-plus iconGreen fa-lg"
                onClick={() =>
                  updateForm(`compressive_strength`, {
                    action: 'addFile',
                  })
                }
              />
            </div>

            <div
              className="row"
              style={{
                margin: '2px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '0px',
              }}
            >
              {disableLocks && (
                <div
                  style={{ padding: '0px' }}
                  className="col-xs-1 col-sm-1 col-md-1"
                >
                  {formState[region.data].loading === 'loading' ? (
                    <i className="fa fa-spinner fa-spin iconRed" />
                  ) : unLockedRegion !== region.data ? (
                    <i
                      key={`icon-lock-green-${region.index}`}
                      onClick={() => onClickLock(region.data)}
                      className="icon fas fa-lock iconGreen fa-lg"
                    />
                  ) : (
                    <i
                      key={`icon-lock-red-${region.index}`}
                      onClick={() => onClickLock(region.data)}
                      className="icon fas fa-unlock-alt iconRed fa-lg"
                    />
                  )}
                </div>
              )}

              <div style={{ padding: '5px' }}>
                {formState.compressive_strength.value.map((d, i) => {
                  return (
                    <Fragment key={`compressive_strength ${i}`}>
                      <div
                        style={
                          formState[`compressive_strength`]?.status[`row${i}`]
                            ?.length
                            ? {
                                outline: '1px solid #ff0000',
                                marginBottom: '10px',
                              }
                            : { marginBottom: '10px' }
                        }
                      >
                        <center>
                          <input
                            onMouseOver={() =>
                              setShowToolTip(`compressive_strength_day${i}`)
                            }
                            onMouseOut={() => setShowToolTip('')}
                            type="text"
                            value={formState.compressive_strength.value[i].day}
                            onChange={(event) =>
                              updateForm(`compressive_strength`, {
                                action: 'updateDay',
                                day: event.target.value,
                                positionI: i,
                              })
                            }
                            style={
                              formState[`compressive_strength`]?.status[
                                `day${i}`
                              ]?.length
                                ? concreteErrorStyleDay
                                : dayStyle
                            }
                          />
                          <AccionaTooltip
                            style={{ position: 'absolute' }}
                            stylel2={{ top: '0px', left: '90px' }}
                            label={`compressive_strength_message_row_${i}`}
                            status={
                              formState[`compressive_strength`]?.status[
                                `row${i}`
                              ]
                            }
                            showToolTip={
                              showToolTip === `compressive_strength_row${i}` ||
                              showToolTip === 'all'
                            }
                          />
                          <span
                            onMouseOver={() =>
                              setShowToolTip(`compressive_strength_row${i}`)
                            }
                            onMouseOut={() => setShowToolTip('')}
                          >
                            {' '}
                            {intl.formatMessage({ id: 'days' })}{' '}
                          </span>
                          <i
                            style={{ marginLeft: 15 }}
                            className="icon fas fa-trash-alt iconRed fa-lg"
                            onClick={() =>
                              updateForm(`compressive_strength`, {
                                action: 'deleteFile',
                                deleteRawI: i,
                              })
                            }
                          />
                        </center>
                        <AccionaTooltip
                          style={{ position: 'absolute' }}
                          stylel2={{ top: '10px', left: '60px' }}
                          label={`compressive_strength_message_${i}`}
                          status={
                            formState[`compressive_strength`]?.status[`day${i}`]
                          }
                          showToolTip={
                            showToolTip === `compressive_strength_day${i}` ||
                            showToolTip === 'all'
                          }
                        />
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          {[1, 2, 3].map((j) => {
                            return (
                              <Fragment key={`compressive_strength_${i}_${j}`}>
                                <input
                                  onMouseOver={() =>
                                    setShowToolTip(
                                      `compressive_strength_${i}_${j}`,
                                    )
                                  }
                                  onMouseOut={() => setShowToolTip('')}
                                  value={
                                    formState.compressive_strength.value[i][
                                      `value${j}`
                                    ]
                                  }
                                  disabled={
                                    formState[region.data].loading ===
                                      'loading' || !region.data
                                  }
                                  onChange={(event) =>
                                    updateForm(`compressive_strength`, {
                                      action: 'updateValue',
                                      value: event.target.value,
                                      positionI: i,
                                      positionJ: j,
                                    })
                                  }
                                  type="text"
                                  style={
                                    formState[`compressive_strength`]?.status[
                                      `value${i}${j}`
                                    ]?.length
                                      ? concreteErrorStyle
                                      : concreteStyle
                                  }
                                />
                                <AccionaTooltip
                                  style={{ position: 'absolute' }}
                                  stylel2={{
                                    top: '65px',
                                    left: `${(j - 1) * 90}px`,
                                  }}
                                  label={`compressive_strength_message_${i}_${j}`}
                                  status={
                                    formState[`compressive_strength`]?.status[
                                      `value${i}${j}`
                                    ]
                                  }
                                  showToolTip={
                                    showToolTip ===
                                      `compressive_strength_${i}_${j}` ||
                                    showToolTip === 'all'
                                  }
                                />
                              </Fragment>
                            );
                          })}
                        </div>
                      </div>
                    </Fragment>
                  );
                })}
              </div>

              {formValidate[region.data] !== undefined ? (
                <div
                  style={{ padding: '0px' }}
                  className="col-xs-1 col-sm-1 col-md-1"
                >
                  {formValidate[region.data] === true ? (
                    <i
                      style={{ float: 'right' }}
                      onClick={() => manualValidationCS(false, region.data)}
                      className="iconGreen fas fa-check-circle fa-lg"
                    ></i>
                  ) : (
                    <i
                      style={{ float: 'right' }}
                      onClick={() => manualValidationCS(true, region.data)}
                      className="iconRed fas fa-times-circle fa-lg"
                    ></i>
                  )}
                </div>
              ) : null}
            </div>
          </label>
        </div>
      </li>
    );
  };

  const fileGenerator = (region) => {
    return (
      <li
        key={`formTable-li-${region.index}`}
        id={`formTable-li-${region.index}`}
      >
        <div
          onMouseOver={() => setShowToolTip(region.data)}
          onMouseOut={() => setShowToolTip('')}
          style={{
            backgroundColor:
              selectedRegion === region.data
                ? 'rgba(240, 150, 0, 0.6)'
                : 'white',
          }}
        >
          <div style={{ padding: '15px 0px 0px 25px', position: 'absolute' }}>
            <AccionaTooltip
              label={region.data}
              status={formState[region.data]?.status}
              showToolTip={showToolTip === region.data || showToolTip === 'all'}
            />
          </div>
          <input
            onChange={() => {}}
            checked={false}
            type="checkbox"
            id={`formTable-input-${region.index}`}
            value={region.index}
          />
          <label
            onClick={(e) => onClick(e, region)}
            style={{ padding: '10px' }}
            id={`formTable-label-${region.index}`}
          >
            {intl.formatMessage({ id: `attr.${region.data}` })}
            <div
              className="row"
              style={{
                margin: '2px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '0px',
              }}
            >
              {!disableLocks && (
                <div
                  style={{ padding: '0px' }}
                  className="col-xs-1 col-sm-1 col-md-1"
                >
                  {formState[region.data].loading === 'loading' ? (
                    <i className="fa fa-spinner fa-spin iconRed" />
                  ) : unLockedRegion !== region.data ? (
                    <i
                      key={`icon-lock-green-${region.index}`}
                      onClick={() => onClickLock(region.data)}
                      className="icon fas fa-lock iconGreen fa-lg"
                    />
                  ) : (
                    <i
                      key={`icon-lock-red-${region.index}`}
                      onClick={() => onClickLock(region.data)}
                      className="icon fas fa-unlock-alt iconRed fa-lg"
                    />
                  )}
                </div>
              )}
              <input
                value={formState[region.data]?.value || ''}
                disabled={
                  formState[region.data].loading === 'loading' || !region.data
                }
                onChange={(event) =>
                  updateForm(region.data, event.target.value)
                }
                type="text"
                style={
                  formState[region.data]?.status.length
                    ? errorStyle
                    : successStyle
                }
              />
              {formValidate[region.data] !== undefined ? (
                <div
                  style={{ padding: '0px' }}
                  className="col-xs-1 col-sm-1 col-md-1"
                >
                  {formValidate[region.data] === true ? (
                    <i
                      style={{ float: 'right' }}
                      onClick={() => manualValidation(false, region.data)}
                      className="iconGreen fas fa-check-circle fa-lg"
                    ></i>
                  ) : (
                    <i
                      style={{ float: 'right' }}
                      onClick={() => manualValidation(true, region.data)}
                      className="iconRed fas fa-times-circle fa-lg"
                    ></i>
                  )}
                </div>
              ) : null}
            </div>
          </label>
        </div>
      </li>
    );
  };

  return (
    <div
      className="select-multiple"
      style={{
        maxHeight: 'none',
      }}
    >
      <label style={{ textTransform: 'uppercase', fontSize: '12px' }}>
        {intl.formatMessage({ id: 'requiredFields' })}
      </label>
      <ul>
        {regionsG1.map((region) => {
          if (region.data === 'manufacture_time')
            return limitTimeRegion(region);
          else if (region.data === 'compressive_strength')
            return compressiveStrengthRegion(region);
          else return fileGenerator(region);
        })}
      </ul>
      {regionsG2.length > 0 ? (
        <>
          <label style={{ textTransform: 'uppercase', fontSize: '12px' }}>
            {intl.formatMessage({ id: 'otherFields' })}{' '}
            {!disableReload && (
              <ReloadIcon
                reloadFunction={() => readOtherRegions(regionsG2)}
              ></ReloadIcon>
            )}
          </label>
          <ul>
            {regionsG2.map((region) => {
              if (region.data === 'manufacture_time')
                return limitTimeRegion(region);
              else if (region.data === 'compressive_strength')
                return compressiveStrengthRegion(region);
              else return fileGenerator(region);
            })}
          </ul>
        </>
      ) : null}
    </div>
  );
};

ScannedDocTable.propTypes = {
  regions: PropTypes.arrayOf(PropTypes.object).isRequired,
  onClick: PropTypes.func.isRequired,
  updateForm: PropTypes.func.isRequired,
  formState: PropTypes.object.isRequired,
  selectedRegion: PropTypes.string.isRequired,
  unLockedRegion: PropTypes.string.isRequired,
  onClickLock: PropTypes.func.isRequired,
  formValidate: PropTypes.object.isRequired,
  dispatchValidable: PropTypes.func.isRequired,
  setForceTooltip: PropTypes.func.isRequired,
  forceTooltip: PropTypes.bool.isRequired,
  readOtherRegions: PropTypes.func.isRequired,
  disableLocks: PropTypes.bool,
  disableReload: PropTypes.bool,
};

ScannedDocTable.defaultProps = {
  disableLocks: false,
  disableReload: false,
};

export default ScannedDocTable;
